export default "__VITE_ASSET__563722db__"